import { render, staticRenderFns } from "./EventHandlerDetails.vue?vue&type=template&id=6b37fcb6"
import script from "./EventHandlerDetails.vue?vue&type=script&lang=js"
export * from "./EventHandlerDetails.vue?vue&type=script&lang=js"
import style0 from "./EventHandlerDetails.vue?vue&type=style&index=0&id=6b37fcb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports